
namespace GeniuzPOS.ReportMasterData {
    import fld = Report_1501_NRow.Fields;
    @Serenity.Decorators.registerClass()
    export class Report_1501_NGrid extends Serenity.EntityGrid<Report_1501_NRow, any> {
        protected getColumnsKey() { return Report_1501_NColumns.columnsKey; }
        protected getDialogType() { return Report_1501_NDialog; }
        protected getIdProperty() { return Report_1501_NRow.idProperty; }
        protected getInsertPermission() { return Report_1501_NRow.insertPermission; }
        protected getLocalTextPrefix() { return Report_1501_NRow.localTextPrefix; }
        protected getService() { return Report_1501_NService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        private getFilterDescriptions(grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions): any {
            let request = Q.deepClone(grid.view.params) as Serenity.ListRequest;
            let columns = Object.keys(options.columnStyles)

           let descriptions: string[] = [];


            if (request?.EqualityFilter) {
                let quickFilters = this.getQuickFilters();

                let filters = Object.keys(request.EqualityFilter);

                for (let filterCol of filters) {
                    let quickFilter = Q.first(quickFilters, x => x.field === filterCol);
                    let filterValue = request.EqualityFilter[filterCol];
                    // if else{
                    if (filterValue.length > 0) {
                        if (Array.isArray(filterValue)) {
                            if (quickFilter.options.lookupKey) {
                                // console.log(filterValue);
                                (filterValue as any[]).forEach(value => {
                                    var names: string[] = new Array(filterValue);
                                    for (var i = 0; i < names.length; i++) {
                                        filterValue = (names[i]);
                                        console.log(filterValue);
                                    }
                                })

                            }
                        } else {
                            filterValue
                        }
                    }
                    else {
                        filterValue = "ไม่ระบุ"
                    }
                    // }

                    let n = columns.find(n => {
                        return options.columnStyles[n]['field'] === filterCol
                    });
                    if (n) {
                        descriptions.push(`${options.columnStyles[n]['title']} = ${filterValue}`)
                    }
                }
            }
            return [descriptions, gridColumns];
        }
        protected createQuickSearchInput() {
        }

        protected getColumns() {
            var columns = super.getColumns();

            return columns;
        }

        protected usePager() {
            return false;
        }
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            // need to turn grouping panel ON for drag drop grouping to work properly
            opt.groupingPanel = true;
            return opt;
        }
        protected getButtons() {
            var buttons = super.getButtons();

            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)

            // Add buttons import excel, pdf
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: Report_1501_NService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            // let reportTitle = 'รายงานเปรียบเทียบรายเดือน ตามหมวดสินค้า'

            // // Max page width = 277
            // let columnStyles: { [dataKey: string]: GeniuzPOS.Common.Helpers.AutoTableStyles } = {
            //     // 0: { field: "ShopName", title: "ร้านค้า[Id]", cellWidth: 30,isHidden:true },
            //     0: { field: "CatName", title: "หมวดสินค้า", cellWidth: 32,overflow:'linebreak'},                
            //     1: { field: "CatCode", title: "หมวดสินค้า", isHidden:true},
            //     2: { field: "Year", title: "ปี",isHidden:true},
            //     3: { field: "TypeSum", title: "type", cellWidth: 8},
            //     4: { field: "January", title: "Jan", cellWidth: 19.75,overflow:'linebreak' ,halign: 'right',aggregate:"sum"},
            //     5: { field: "February", title: "Feb", cellWidth: 19.75,overflow:'linebreak' ,halign: 'right',aggregate:"sum"},
            //     6: { field: "March", title: "Mar", cellWidth: 19.75,overflow:'linebreak' ,halign: 'right',aggregate:"sum"},
            //     7: { field: "April", title: "Apr", cellWidth: 19.75,overflow:'linebreak' ,halign: 'right',aggregate:"sum"},
            //     8: { field: "May", title: "May", cellWidth: 19.75,overflow:'linebreak' ,halign: 'right',aggregate:"sum"},
            //     9: { field: "June", title: "Jun", cellWidth: 19.75,overflow:'linebreak' ,halign: 'right',aggregate:"sum"},
            //     10: { field: "July", title: "Jul", cellWidth: 19.75,overflow:'linebreak' ,halign: 'right',aggregate:"sum"},
            //     11: { field: "August", title: "Aug", cellWidth: 19.75,overflow:'linebreak' ,halign: 'right',aggregate:"sum"},
            //     12: { field: "September", title: "Sep", cellWidth: 19.75,overflow:'linebreak' ,halign: 'right',aggregate:"sum"},
            //     13: { field: "October", title: "Oct", cellWidth: 19.75,overflow:'linebreak' ,halign: 'right',aggregate:"sum"},
            //     14: { field: "November", title: "Nov", cellWidth: 19.75,overflow:'linebreak' ,halign: 'right',aggregate:"sum"},
            //     15: { field: "December", title: "Dec", cellWidth: 19.75,overflow:'linebreak' ,halign: 'right',aggregate:"sum"}
            //     // 8: { field: "AllItemCharge", title: "ค่าชาร์จ", cellWidth: 30,halign: 'right',aggregate:"sum"},
            //     // 9: { field: "VatOfCharge", title: "VAT(ค่าชาร์จ)", cellWidth: 30,halign: 'right',aggregate:"sum"},
            // }

            // buttons.push(GeniuzPOS.Common.Helpers.Report1501PdfHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     separator: true,
            //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),

            //     pageNumbers: true,
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     theme: 'plain',
            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,

            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 12,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         columnStyles: {
            //             OriginalColumn: {
            //                // columnWidth: 25,
            //                 halign: 'right'
            //             }
            //         }
            //     }
            // }));

            // buttons.push(GeniuzPOS.Common.Helpers.Report1501PdfHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     separator: true,
               
            //     pageNumbers: true,
            //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),
            //     autoPrint: true,
            //     output: "dataurlnewwindow",
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     theme: 'plain',

            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,

            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 12,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         columnStyles: {
            //             OriginalColumn: {
            //                // columnWidth: 25,
            //                 halign: 'right'
            //             }
            //         }
            //     }
            // }));
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );

            return buttons;
        }
        
        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            Q.first(filters, x => x.field == fld.Year).init = w => {

                (w as Serenity.StringEditor).value = Q.formatDate((new Date(Date.now())).toDateString(), "yyyy");
                
            };
            return filters;
        }
    }
}